import { BaseTool } from '../BaseTool';

export class PhasingTool extends BaseTool {
    id = 'MANAGE_PHASING';
    name = 'Phasing';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openManageDialog('phasing');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
